import "./App.css";
import AppRoot from "./AppRoot";

//多言語対応
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enJson from "./locales/en-us.json";
import jaJson from "./locales/ja-jp.json";

const App: React.FC = () => {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: enJson },
      ja: { translation: jaJson },
    },
    lng: "ja",
  });
  return (
    <div className="App">
      <AppRoot />
    </div>
  );
};

export default App;
